"use client";

import { CarouselYearCards } from "@bumble/ui-kit";
import { Carousel as CarouselType } from "@/lib/datocms/cma-types";

const PLACEHOLDER_IMAGE = "/assets/placeholder-background.png";

interface CarouselItem {
  id: string;
  title?: string | null;
  description?: string | null;
  image?: {
    url: string;
    alt?: string | null;
  } | null;
  link?: {
    text?: string;
    link?: string;
  };
}

interface Props {
  data: CarouselType & {
    title?: string | null;
    description?: string | null;
    scrollText?: string | null;
    items?: CarouselItem[];
  };
}

export default function Carousel({ data }: Props) {
  const {
    title,
    description,
    scrollText,
    items = [],
  } = data as {
    title?: string | null;
    description?: string | null;
    scrollText?: string | null;
    items?: CarouselItem[];
  };

  const cards = items.map((item) => ({
    title: item.title ?? "",
    description: item.description ?? "",
    type: "year" as const,
    image: {
      alt: item.image?.alt ?? "Placeholder image",
      src: item.image?.url || PLACEHOLDER_IMAGE,
    },
    link: item.link?.link ?? "",
    linkText: item.link?.text ?? "",
  }));

  return (
    <div style={{ padding: "20px 0" }}>
      <CarouselYearCards
        a11yScrollLeftText="Scroll left"
        a11yScrollRightText="Scroll right"
        cards={cards}
        description={description ?? ""}
        scrollText={scrollText ?? "Scroll to explore"}
        title={title ?? ""}
      />
    </div>
  );
}
